import React, { Component } from "react";
import { dataService } from "../../../services/dataService";

class Progress extends Component
{
	constructor ( props )
	{
		super( props );
		this.props = props;

		this.state = {
			knob : 0,
			rangeValue : 0,
			active : false,
			type : 0,
			dragging : false,
		}

	}

	progressBar ()
	{
		// $( function ()
		// {
		// 	let progressBarLine = $( '#progress-bar-line' );
		// 	let h4Sub = $( '#h4-subcontainer > h4' );
		// 	let rangePercent = progressBarLine.val();
		//
		// 	progressBarLine.on( 'change input', function ()
		// 	{
		// 		rangePercent = progressBarLine.val();
		//
		// 		h4Sub.html( rangePercent + '<span></span>' );
		// 		// $('h4').css({'transform': 'translateX(calc(-50% - 20px)) scale(' + (1+(rangePercent/100)) + ')', 'left': rangePercent+'%'});
		// 		h4Sub.css( {
		// 			'transform' : 'translateX(-50%) scale(' + ( 1 + ( rangePercent / 100 ) ) + ')',
		// 			'right' : rangePercent + '%'
		// 		} );
		// 	} );
		// } );

		// $("#progress-bar-line").val(0)

		// $( "#progress-bar-line" ).on( "focus", function ()
		// {
		// 	console.log( "active" );
		// } )
	}

	componentDidUpdate ( previousProps, previousState )
	{
		if ( this.props.width && !this.state.active && this.state.dragging === false)
		{
			if ( previousProps.width !== this.props.width )
			{
				this.setState( { rangeValue : this.props.width } );
			}
		}
	}

	handleRangeChange = async e =>
	{
		if ( e && e.target )
		{
			await this.hanldeProgressLine( e.clientX );

			dataService.setData( {
				progressValue : this.state.rangeValue
			} );
		}
	};

	hanldeProgressLine = ( clientX ) =>
	{
		let parentWidth = document.querySelector( ".progress-bar-div" ).offsetWidth;
		let childWidth = Math.abs(document.querySelector( ".progress-bar-div" ).offsetLeft - clientX);
		let percent = ( ( ( childWidth ) / parentWidth ) * 100 );

		if ( percent > 100 )
			percent = 100;

		this.setState( { rangeValue : percent } );
	};

	mouseDown = e => {
		this.setState( { dragging : true } );

		document.addEventListener('mouseup', this.mouseUp);
		document.addEventListener( 'mousemove', this.mouseMove);
	};

	mouseMove = e => {
		if ( this.state.dragging === true )
		{
			console.log("e.pageX: ", e.pageX);
			this.hanldeProgressLine(e.pageX)
		}
	};

	mouseUp = e =>
	{
		this.setState( { dragging : false } );

		document.removeEventListener("mousemove", this.mouseMove);
		document.removeEventListener("mouseup", this.mouseUp);

		dataService.setData( {
			progressValue : this.state.rangeValue
		} );
	};

	touchStart = e => {
		this.setState( { dragging : true } );

		document.addEventListener('touchend', this.touchEnd);
		document.addEventListener( 'touchmove', this.touchMove);
	};

	touchMove = e => {
		if ( this.state.dragging === true )
		{
			this.hanldeProgressLine(e.touches[0].pageX)
		}
	};

	touchEnd = e => {
		this.setState( { dragging : false } );

		document.removeEventListener("touchend", this.touchEnd);
		document.removeEventListener("touchmove", this.touchMove);

		dataService.setData( {
			progressValue : this.state.rangeValue
		} );
	};

	startSeek = () =>
	{
		this.setState( { active : true } )
	};

	stopSeek = () =>
	{
		this.setState( { active : false } );

		dataService.setData( {
			progressValue : ( 100 - this.state.rangeValue )
		} );

	};

	render ()
	{

		this.progressBar();

		return (
			<>
				{
					this.props.type === 1 &&
					<div onMouseMove={this.props.onMouseMove} className="progress-bar-line" style={{
						"width" : this.props.width + "%",
						"background" : this.props.backgroundColor
					}}/>
				}
				{
					this.props.type === 0 &&
					<div className="position-relative progress-bar-div">
						<div className="progress-bar-back" onClick={this.handleRangeChange} >
							<div style={{ "width" : Math.round( this.state.rangeValue ) + "%" }}
							     className="progress-bar-line" id="progress-bar-line" />
							<svg id="progress-bar-line-bullet" draggable="true" onMouseDown={this.mouseDown} onTouchStart={this.touchStart} data-v-f918babe="" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ left : Math.round( this.state.rangeValue ) + "%" }} className="dark-ranger__thumb w-3 h-3 -ml-1">
								<path d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="white"/>
							</svg>
						</div>
					</div>
				}
			</>
		)
	}
}

export default Progress;